export const qplAcceptanceDecisionTypes = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
};
